import {
  finderBackgroundLockProps,
  finderShowsBottomBar,
} from "@/ui/finder/finderMode";
import { useCallback, type ReactNode } from "react";
import { Platform, View } from "react-native";

/**
 * react-native-web nimmt `inert` in die weitergeleiteten Props auf und
 * verwirft es danach in createDOMProps. React 19 entfernt zusätzlich
 * `inert=""`. Deshalb setzt die Hülle das Attribut am DOM-Knoten.
 */
function applyWebBackgroundLock(node: unknown, active: boolean) {
  if (!node || typeof node !== "object") return;
  const el = node as {
    inert?: boolean;
    setAttribute?: (name: string, value: string) => void;
    removeAttribute?: (name: string) => void;
  };
  if (typeof el.setAttribute !== "function" || typeof el.removeAttribute !== "function") {
    return;
  }
  if (active) {
    el.inert = true;
    el.setAttribute("inert", "");
    el.setAttribute("aria-hidden", "true");
    return;
  }
  el.inert = false;
  el.removeAttribute("inert");
  el.removeAttribute("aria-hidden");
}

/**
 * Hülle unter dem Finder-Overlay: gesperrt, solange die Sperre aktiv ist,
 * egal ob das Gate oder der Notfall-Screen rendert. Die Bottom-Bar entfällt dann.
 */
export function FinderAppChrome({
  finderActive,
  isWide,
  bottomBar,
  children,
}: {
  finderActive: boolean;
  isWide: boolean;
  bottomBar: ReactNode;
  children: ReactNode;
}) {
  const lock = finderBackgroundLockProps(finderActive, Platform.OS);
  const setHostRef = useCallback(
    (node: View | null) => {
      if (Platform.OS !== "web") return;
      applyWebBackgroundLock(node, finderActive);
    },
    [finderActive],
  );

  return (
    <View
      ref={setHostRef}
      testID="finder-app-chrome"
      style={{ flex: 1, minWidth: 0, minHeight: 0 }}
      {...lock}
    >
      {children}
      {finderShowsBottomBar(isWide, finderActive) ? bottomBar : null}
    </View>
  );
}
